const strings = {
  CANCEL: 'Avbryt',
  DONE: 'Klar',
  UNBOOK_LAUNDRY_TIME_UPDATED: 'Tvättiden har avbokats',
  LAUNDRY_TIME_FOR_APARTMENT: 'Boka eller avboka tvättid för lägenhet ',
  LAUNDRY_TIME_INFO:
    'Här kan du som administratör boka eller avboka en annan användares tvättid.',
  LAUNDRY_TYPE_UPDATED: 'Tvättypen har uppdaterats',
  INTERNAL_ERROR: 'Ett oväntat fel har uppstått, var god försök igen.',
  NO_BOOKINGS: ' har inga tvättbokningar.',
  APARTMENT: 'Lägenhet',
  LAUNDRY: {
    M: 'Tvättmaskin',
    S: 'Tvättstuga'
  },
  SELECT_DATE_FOR_BOOKING: 'Välj ett datum för tvättbokning',
  CURRENT_BOOKINGS: 'Nuvarande bokningar för lägenhet ',
  FREE_LAUNDRY_TIME: 'Lediga tvättider (',
  LAUNDRY_TIME_BOOKED: 'Tvättiden har bokats',
  LAUNDRY_TIME_UNBOOKED: 'Tvättiden har avbokats',
  CREATE_BOOKABLE_SYSTEM: 'Skapa bokningssystem',
  CREATE_BOOKABLE_SYSTEM_INFO:
    'Fyll i fälten nedan för att skapa ett nytt bokningssystem.',
  TITLE: 'Titel (t.ex. Bastu)*',
  FIRST_TIME: 'Första tiden*',
  LENGTH_OF_TIME: 'Längd på tider*',
  NUMBER_OF_TIMES: 'Antal tider*',
  MANDATORY_FIELD: 'Fältet är oblikatoriskt',
  CREATED: 'har skapats'
}

export default strings



// WEBPACK FOOTER //
// ./src/components/containers/CreateBookingSystemModal/strings.js